// extracted by mini-css-extract-plugin
module.exports = {"search-box":"SearchBox_search-box__3Hx8n","light":"SearchBox_light__1Uicf","dark":"SearchBox_dark__3HGUx"};